export function isAfter(date1: Date | string, date2: Date | string) {
  return new Date(date1).getTime() > new Date(date2).getTime();
}

export default null; // silence a false warning
